const featuresPay = {
    featureTitle: 'Buat Keputusan Bisnis Berdasarkan Data',
    featureDescription:
        'Ketahui item mana yang paling laku dan memberikan keuntungan terbesar, serta akses laporan keuangan kapan saja dan di mana saja. Bisnis Anda ada di genggaman tangan!',
    featureButton: "Langganan Premium",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: 'Mulai dari',
    featureEndingText: 'Ribu',

    features: [
        {
            title: 'Item Tanpa Batas',
            description: 'Tambahkan semua item yang Anda miliki tanpa batasan.'
        },
        {
            title: 'Staf Tanpa Batas',
            description: 'Tambahkan Staf/Admin ke bisnis tanpa batasan.'
        },
        {
            title: 'Riwayat Tanpa Batas',
            description: 'Lihat perubahan pada catatan stok lama tanpa batasan.'
        },
        {
            title: 'Filter Riwayat',
            description: 'Lihat riwayat dengan mudah berdasarkan tipe, kategori, staf, dan tanggal.'
        },
        {
            title: 'Unduh ke Excel',
            description: 'Dapatkan riwayat catatan stok ke Microsoft Excel dengan sekali klik.'
        },
        {
            title: 'Unduh ke PDF',
            description: 'Dapatkan daftar item dan stok terbaru dalam format PDF dengan sekali klik.'
        }
    ],
    warehousesGuide: [
        {
            desc: 'Buat beberapa gudang untuk manajemen stok yang lebih baik.'
        },
        {
            desc: 'Tetapkan produk ke lokasi tertentu.'
        },
        {
            desc: 'Pantau tingkat persediaan di seluruh gudang.'
        }
    ],
    addVariantsGuide: [
        { desc: 'Tambahkan varian ukuran, warna, atau bahan.' },
        { desc: 'Tetapkan tingkat stok per varian.' },
        { desc: 'Lacak stok di seluruh gudang.' }
    ]
}

export default featuresPay
